import React from "react";
import styles from "./styles.module.scss";
import WarningDiamond from "../../assets/svg/icons/common/warning-diamond";

const getIcon = (type) => {
  switch (type) {
    case "warning":
      return <WarningDiamond />;
  }
};

export const Alert = ({ type, children }) => {
  return (
    <div className={`${styles.alert} ${styles[type]}`}>
      {getIcon(type)}
      <div className={styles.alertContent}>{children}</div>
    </div>
  );
};

export default Alert;
